<template>
  <div class="flex flex-col gap-4">
    <V4LearningPathFilters />
    <div class="flex flex-col gap-2">
      <V4LearningPathGrid />

      <div
        class="flex justify-center items-center py-5"
        v-if="!isLastPage && !initializeLoading"
      >
        <button
          v-if="!loadingLearningPath"
          @click="handleClickLoadMore"
          class="inline-flex justify-center items-center gap-1.5 px-3 py-2 text-sm font-medium rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors truncate min-w-0 cursor-pointer"
          type="primary"
        >
          Load More
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useHomeLearningPathStore } from "@/stores/home/useHomeLearningPath.store";
import { onMounted, watch } from "vue";
import { storeToRefs } from "pinia";
import { defineOptions } from "vue";
import { debounce as _debounce } from "lodash-es";
import V4LearningPathFilters from "./filters/V4LearningPathFilters.vue";
import V4LearningPathGrid from "./partials/V4LearningPathGrid.vue";

defineOptions({
  inheritAttrs: false,
});

const homeLearningPathStore = useHomeLearningPathStore();

const {
  sortBy,
  filterBy,
  filterByPrivacy,
  isLastPage,
  totalItems,
  initializeLoading,
  loadingLearningPath,
} = storeToRefs(homeLearningPathStore);

const handleFetchLearningPath = async () => {
  await homeLearningPathStore.handleFetchLearningPath();
};

const handleClickLoadMore = async () => {
  totalItems.value += 10;
  await handleFetchLearningPath();
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: "smooth",
  });
};

const onFilteredLearningPath = _debounce(function () {
  handleFetchLearningPath();
  homeLearningPathStore.handleResetList();
}, 1000);

onMounted(async () => {
  homeLearningPathStore.handleResetList();
  await handleFetchLearningPath();
});

watch([sortBy, filterBy, filterByPrivacy], () => {
  onFilteredLearningPath();
});
</script>

<style lang="css" scoped>
.slide-fade-enter-active {
  transition: all 0.2s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
